/**
 * Quoted UK mortgage rates, by fixed term and loan to value band.
 *
 * Generated by ./scripts/rates — do not edit by hand. The source is the
 * Bank of England's database of quoted household interest rates, which is
 * what lenders were advertising, averaged across the market. Rates are
 * fractions, as everywhere else in src/lib.
 */

/** The month the Bank of England published these for. */
export const RATES_AS_AT = 'July 2026';

/** IUMTLMV: what you fall onto when the fixed term ends. */
export const REVERT_TO_RATE = 0.066;

export const QUOTED_RATES = [
    {
        fixed_term: 2,
        maximum_loan_to_value: 0.6,
        initial_interest: 0.0461,
        series: 'IUMZICQ',
    },
    {
        fixed_term: 2,
        maximum_loan_to_value: 0.75,
        initial_interest: 0.0479,
        series: 'IUMBV34',
    },
    {
        fixed_term: 2,
        maximum_loan_to_value: 0.9,
        initial_interest: 0.0507,
        series: 'IUMB482',
    },
    {
        fixed_term: 2,
        maximum_loan_to_value: 0.95,
        initial_interest: 0.0549,
        series: 'IUM2WTL',
    },
    {
        fixed_term: 3,
        maximum_loan_to_value: 0.75,
        initial_interest: 0.0468,
        series: 'IUMBV37',
    },
    {
        fixed_term: 5,
        maximum_loan_to_value: 0.6,
        initial_interest: 0.0449,
        series: 'IUMZO27',
    },
    {
        fixed_term: 5,
        maximum_loan_to_value: 0.75,
        initial_interest: 0.0461,
        series: 'IUMBV42',
    },
    {
        fixed_term: 5,
        maximum_loan_to_value: 0.9,
        initial_interest: 0.0487,
        series: 'IUMZO28',
    },
    {
        fixed_term: 5,
        maximum_loan_to_value: 0.95,
        initial_interest: 0.0529,
        series: 'IUM5WTL',
    },
];
